import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Product as CoreProduct, IProductDataV2, } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { AbIfService } from '@df/module-ab/ab-if.service';
import { Ab } from '@df/module-ab/ab.namespace';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { SearchOutletComponentDef } from '@df/search/search-outlet.component.def';
import { Search } from '@df/search/search.interfaces';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { ModalOverlay } from '@df/ui/modal/modal-overlay';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { ModalModule } from '@df/ui/modal/modal.module';
import { ModalService } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { Subscription } from 'rxjs';
import { Product } from '../../catalog/product/product.decorator';
import { ProductComponent } from '../../catalog/product/product/product.component';
import { SearchBannerComponent } from './search-banner.component';
import { SearchLinksComponent } from './search-links.component';
import { SearchTrendingComponent } from './search-trending.component';

@Component({
    selector: 'search-outlet',
    templateUrl: 'search-outlet.html',
    styleUrls: ['search-outlet.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        SearchBannerComponent,
        SearchTrendingComponent,
        ProductComponent,
        GridModule,
        TranslationModule,
        RouterLink,
        SearchLinksComponent,
        CommonModule,
        ModalModule
    ]
})
export class SearchOutletComponent extends SearchOutletComponentDef implements OnInit, OnDestroy {
    @ViewChild('searchOutletTemplete')
    searchOutletTemplete?: TemplateRef<any>;
    private _searchOutletModalRef?: ModalRef<TemplateRef<any>>;
    protected subscriptions = new Subscription();
    // protected listingSubscription?: Subscription;
    isOpen = false;
    searchExperimentVariant?: Ab.TVariant;

    protected modalService = inject(ModalService);
    protected modalOverlay = inject(ModalOverlay);
    protected app = inject(App);
    protected abIfService = inject(AbIfService);

    protected override searchService = inject(KlevuSearchService);

    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(this.app.events.on('search.open').subscribe(value => this.toggle(value)));
        this.subscriptions.add(
            this.abIfService.getState(`(trustSignals) ${this.app.ab.getVariant('trustSignals')}`).subscribe(() => {
                this.app.ab.getVariant('trustSignals') === 'B'
                    ? this._searchOutletModalRef?.addPanelClass('search-outlet-usps-bar-open')
                    : this._searchOutletModalRef?.removePanelClass('search-outlet-usps-bar-open');
                this._ref.detectChanges();
            })
        );
        this.searchService?.loadKlevuVars(() => this._ref.detectChanges());
    }
    override ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    get popularTerms() {
        return this.searchService?.webstorePopularTerms;
    }
    override hide() {
        super.hide();
        this.closeModal();
    }
    protected toggle(value = false) {
        if (value) {
            this.openModal();
        } else {
            this.closeModal();
        }
    }
    protected openModal() {
        this.searchOutletTemplete &&
            (this._searchOutletModalRef = this.modalService.open(
                this.searchOutletTemplete,
                {
                    minHeight: '100%',
                    maxWidth: '100vw',
                    width: '1126px',
                    hasBackdrop: true,
                    backdropClass: 'search-outlet-backdrop-dark',
                    trapFocus: false,
                    modalClass: 'search-outlet-modal',
                    panelClass:
                        this.app.ab.getVariant('trustSignals') === 'B'
                            ? ['search-outlet-panel', 'search-outlet-usps-bar-open']
                            : 'search-outlet-panel',
                    position: {
                        top: '0'
                    },
                    transformOptions: `translate3d(0, -100%, 0)`,
                    transitionOptions: '500ms ease-in-out',
                    scrollStrategy: this.modalOverlay.scrollStrategies.block()
                },
                'custom'
            ));
        if (this._searchOutletModalRef) {
            this.subscriptions.add(
                this._searchOutletModalRef.afterOpened().subscribe(() => this.app.events.broadcast('search.focus', true))
            );
            this.subscriptions.add(
                this._searchOutletModalRef.afterClosed().subscribe(() => this.app.events.broadcast('search.reset', false))
            );
        }
    }
    protected closeModal() {
        if (this._searchOutletModalRef) {
            this._searchOutletModalRef.close();
        }
    }
    trackByTerm(index: number, term: Search.ITerm): string {
        return term.phrase;
    }
    protected override onProductListingUpdate(): void {
        this._ref.detectChanges();
        this._searchOutletModalRef?.containerInstance.detectChanges();
    }

    asLocalProduct(product: CoreProduct<IProductDataV2>): Product<IProductDataV2> {
        return product as Product<IProductDataV2>;
    }
}
